import { ENDPOINTS } from "../../apiConfig";
import axiosRequest from "../universal/axiosService";

export const fetchOnboardings = async ({
  limit,
  page,
  filters,
  sort,
  ret,
  ref,
  incl,
}) => {
  try {
    const [onboardingsResponse, totalCountResponse] = await Promise.all([
      axiosRequest({
        method: "GET",
        url: ENDPOINTS.ONBOARDINGS.GET_ALL,
        params: {
          coll: "Onboarding",
          lim: limit,
          pg: page,
          fil: JSON.stringify(filters),
          cache: false,
          sort: JSON.stringify(sort),
          ret,
          ref,
          incl,
        },
      }),
      axiosRequest({
        method: "GET",
        url: ENDPOINTS.ONBOARDINGS.GET_TOTAL_COUNT,
        params: {
          coll: "Onboarding",
          fil: JSON.stringify(filters),
        },
      }),
    ]);

    return {
      data: onboardingsResponse.data,
      totalCount: totalCountResponse.data,
    };
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

export const getTotalCountsOnboarding = async ({ filters }) => {
  try {
    const [totalCountResponse] = await Promise.all([
      axiosRequest({
        method: "GET",
        url: ENDPOINTS.ONBOARDINGS.GET_TOTAL_COUNT,
        params: {
          coll: "Onboarding",
          fil: JSON.stringify(filters),
        },
      }),
    ]);

    return {
      totalCount: totalCountResponse.data,
    };
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

export const fetchOneOnboarding = async ({ uiid, retrieve, ref, incl }) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.ONBOARDINGS.GET_BY_UIID,
    params: {
      coll: "Onboarding",
      ret: retrieve,
      ref: ref,
      fil: JSON.stringify({ uiid: { type: "NONE", value: uiid } }),
      incl,
    },
  });
};

export const addOnboarding = async (data) => {
  console.log({ addOnboardingapi: data });
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.ONBOARDINGS.ADD_NEW,
    data: {
      coll: "Onboarding",
      payload: data,
    },
  });
};

export const updateOnboarding = async ({
  coll,
  uiid,
  payload,
  patchId,
  tPath,
  postActions,
}) => {
  const params = {
    coll,
    uiid,
    ...(patchId && { patchId }),
    ...(tPath && { tPath }),
  };

  return await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.ONBOARDINGS.UPDATE,
    data: {
      payload,
      ...(postActions && { postActions }),
    },
    params,
  });
};

// E-Onboarding Checklist APIS
// E-Onboarding Checklist APIS
// E-Onboarding Checklist APIS

export const fetchChecklists = async ({
  limit,
  page,
  filters,
  sort,
  ret,
  ref,
  incl,
}) => {
  try {
    const [checklistsResponse, totalCountResponse] = await Promise.all([
      axiosRequest({
        method: "GET",
        url: ENDPOINTS.CHECKLISTS.GET_ALL,
        params: {
          coll: "Checklist",
          lim: limit,
          pg: page,
          fil: JSON.stringify(filters),
          cache: false,
          sort: JSON.stringify(sort),
          ret,
          ref,
          incl,
        },
      }),
      axiosRequest({
        method: "GET",
        url: ENDPOINTS.CHECKLISTS.GET_TOTAL_COUNT,
        params: {
          coll: "Checklist",
          fil: JSON.stringify(filters),
        },
      }),
    ]);

    return {
      data: checklistsResponse.data,
      totalCount: totalCountResponse.data,
    };
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

export const fetchOneChecklist = async ({ uiid, retrieve, ref, incl }) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.CHECKLISTS.GET_BY_UIID,
    params: {
      coll: "Checklist",
      ret: retrieve,
      ref: ref,
      fil: JSON.stringify({ uiid: { type: "NONE", value: uiid } }),
      incl,
    },
  });
};

export const addChecklist = async (data) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.CHECKLISTS.ADD_NEW,
    data: {
      coll: "Checklist",
      payload: data,
    },
  });
};

export const updateChecklist = async ({
  coll,
  uiid,
  payload,
  patchId,
  tPath,
}) => {
  const params = {
    coll,
    uiid,
    ...(patchId && { patchId }),
    ...(tPath && { tPath }),
  };

  return await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.CHECKLISTS.UPDATE,
    data: { payload },
    params,
  });
};

//New E-Onboarding Document APIS
//New E-Onboarding Document APIS
//New E-Onboarding Document APIS

export const fetchDocuments = async ({
  limit,
  page,
  filters,
  sort,
  ret,
  ref,
  incl,
}) => {
  try {
    const [documentsResponse, totalCountResponse] = await Promise.all([
      axiosRequest({
        method: "GET",
        url: ENDPOINTS.CHECKLISTS.GET_ALL,
        params: {
          coll: "Document",
          lim: limit,
          pg: page,
          fil: JSON.stringify(filters),
          cache: false,
          sort: JSON.stringify(sort),
          ret,
          ref,
          incl,
        },
      }),
      axiosRequest({
        method: "GET",
        url: ENDPOINTS.CHECKLISTS.GET_TOTAL_COUNT,
        params: {
          coll: "Document",
          fil: JSON.stringify(filters),
        },
      }),
    ]);

    return {
      data: documentsResponse.data,
      totalCount: totalCountResponse.data,
    };
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

export const fetchOneDocument = async ({ uiid, retrieve, ref, incl }) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.CHECKLISTS.GET_BY_UIID,
    params: {
      coll: "Document",
      ret: retrieve,
      ref: ref,
      fil: JSON.stringify({ uiid: { type: "NONE", value: uiid } }),
      incl,
    },
  });
};

export const addOnboardingDocument = async (data) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.CHECKLISTS.ADD_NEW,
    data: {
      coll: "Document",
      payload: data,
    },
  });
};

export const updateDocument = async ({
  coll,
  uiid,
  payload,
  patchId,
  tPath,
}) => {
  const params = {
    coll,
    uiid,
    ...(patchId && { patchId }),
    ...(tPath && { tPath }),
  };

  return await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.CHECKLISTS.UPDATE,
    data: { payload },
    params,
  });
};

//New PdfTemplate Document APIS
//New PdfTemplate Document APIS
//New PdfTemplate Document APIS

export const fetchPdfTemplates = async ({
  limit,
  page,
  filters,
  sort,
  ret,
  ref,
  incl,
}) => {
  try {
    const [templatesResponse, totalCountResponse] = await Promise.all([
      axiosRequest({
        method: "GET",
        url: ENDPOINTS.PDFTEMPLATES.GET_ALL,
        params: {
          coll: "PdfTemplate",
          lim: limit,
          pg: page,
          fil: JSON.stringify(filters),
          cache: false,
          sort: JSON.stringify(sort),
          ret,
          ref,
          incl,
        },
      }),
      axiosRequest({
        method: "GET",
        url: ENDPOINTS.PDFTEMPLATES.GET_TOTAL_COUNT,
        params: {
          coll: "PdfTemplate",
          fil: JSON.stringify(filters),
        },
      }),
    ]);

    return {
      data: templatesResponse.data,
      totalCount: totalCountResponse.data,
    };
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

export const fetchOnePdfTemplate = async ({ uiid, retrieve, ref, incl }) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.PDFTEMPLATES.GET_BY_UIID,
    params: {
      coll: "PdfTemplate",
      ret: retrieve,
      ref: ref,
      fil: JSON.stringify({ uiid: { type: "NONE", value: uiid } }),
      incl,
    },
  });
};

export const addPdfTemplate = async (data) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.PDFTEMPLATES.ADD_NEW,
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const updatePdfTemplate = async ({
  coll,
  uiid,
  payload,
  patchId,
  tPath,
}) => {
  const params = {
    coll,
    uiid,
    ...(patchId && { patchId }),
    ...(tPath && { tPath }),
  };

  return await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.PDFTEMPLATES.UPDATE,
    data: { payload },
    params,
  });
};
